import { useRecoilValue } from "recoil";
import { appData } from "recoil/app";
import style from "./ProgressBar.module.scss";
type Props = {
  step: number;
  maxStep: number;
};

const ProgressBar = (props: Props) => {
  const { theme } = useRecoilValue(appData);

  const width = ((props.step - 1) / props.maxStep) * 100;
  return (
    <>
      <div className={style.ProgressText}>
        <span className={style.now}>{props.step}</span>
        <span className={style.total}>/ {props.maxStep}</span>
      </div>
      <div className={style.ProgressBar}>
        <div className={style.inner}>
          <div
            className={style.progress}
            style={{
              backgroundColor: theme?.accent,
              width: `${width}%`,
            }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
